import { Set } from 'immutable'
/**
 * @typedef {import('components/CustomerTagInput').CustomerTag} CustomerTag
 *
 * @typedef CustomerTagCreateUpdateDeletePopupState
 * @property {'tagSelection'|'tagCreation'|'tagModification'} state
 * @property {CustomerTag} selectedTagForModification
 * @property {Set<CustomerTag>} selectedTagSet
 *
 * @typedef CustomerTagCreateUpdateDeletePopupAction
 * @property {'CLICK_CREATE_TAG'|'CLICK_MODIFY_TAG'|'CLICK_BACK'|'ADD_TAG'|'REMOVE_TAG'|'SET_CUSTOMER_TAG_SET'} type
 * @property {CustomerTag} [tag]
 * @property {Set<CustomerTag>} [tagSet]
 *
 * @param {CustomerTagCreateUpdateDeletePopupState} state
 * @param {CustomerTagCreateUpdateDeletePopupAction} action
 * @returns {CustomerTagCreateUpdateDeletePopupState}
 */
export default function customerTagCreateUpdateDeletePopupReducer(state, action) {
  if (action.type === 'CLICK_CREATE_TAG') {
    return {
      ...state,
      state: 'tagCreation',
    }
  }

  if (action.type === 'CLICK_MODIFY_TAG') {
    return {
      ...state,
      state: 'tagModification',
      selectedTagForModification: action.tag,
    }
  }

  if (action.type === 'CLICK_BACK') {
    return {
      ...state,
      state: 'tagSelection',
    }
  }

  if (action.type === 'SET_CUSTOMER_TAG_SET') {
    return {
      ...state,
      selectedTagSet: action.tagSet,
    }
  }

  if (action.type === 'ADD_TAG') {
    return {
      ...state,
      selectedTagSet: state.selectedTagSet.add(action.tag),
    }
  }

  if (action.type === 'REMOVE_TAG') {
    return {
      ...state,
      selectedTagSet: state.selectedTagSet.delete(action.tag),
    }
  }

  return state
}

/** @returns {CustomerTagCreateUpdateDeletePopupState} */
export function initState(customerTags) {
  return {
    state: 'tagSelection',
    selectedTagForModification: null,
    selectedTagSet: Set(customerTags),
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/CustomerTagCreateUpdateDeletePopupContent/reducer.js